import { useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";

import { useUpdateDemandPlanVariantMutation } from "@features/demandPlanning/data/demandPlanVariantQueries";
import { DemandPlanVariant } from "@models/DemandPlanVariant";
import { formatNumber, roundUp } from "@utility/utilityFunctions";

import { EditableCell } from "../editor/EditableCell";
import { OrderTotalTooltipTitle } from "./DemandPlanVariantTooltips";

export const DemandPlanVariantToOrderColumn = ({
  demandPlanVariant: dpv,
}: {
  demandPlanVariant: DemandPlanVariant;
}) => {
  const overriden = dpv.toOrder > 0 && dpv.toOrder !== dpv.recommendedToOrder,
    displayValue = overriden ? dpv.toOrder : dpv.recommendedToOrder;
  const updateMutation = useUpdateDemandPlanVariantMutation();
  const { resetField } = useFormContext();

  const onSubmit = useCallback(
    (value) => {
      value = roundUp(value, dpv.variant.item.packSize);

      // do not save 0 or same value, still allow empty strings
      if (
        value !== "0" &&
        value !== dpv.recommendedToOrder &&
        value !== dpv.toOrder
      ) {
        dpv.toOrder = value || "";

        updateMutation.mutate({
          id: dpv.id,
          toOrder: dpv.toOrder.toString(),
        });
      } else {
        resetField(`toOrder-${dpv.id}`, value);
      }
    },
    [dpv, updateMutation, resetField]
  );

  return useMemo(
    () => (
      <EditableCell
        name="toOrder"
        rec={dpv}
        cellClassName={`${overriden ? "text-yellow-700 border-yellow-700" : ""}`}
        tooltipTitle={<OrderTotalTooltipTitle demandPlanVariant={dpv} />}
        onSubmit={onSubmit}
      >
        {formatNumber(displayValue)}
      </EditableCell>
    ),
    [overriden, onSubmit, displayValue, dpv]
  );
};
